Button = require 'components/common/button'
CollapsibleWithControls = require 'components/common/collapsible_with_controls'
ConnectStore = require 'components/enhancers/connect_store'
EllipsizedText = require 'components/common/ellipsized_text'
MiniDSActions = require 'actions/mini_ds_actions'
mediator = require 'mediator'
ProgressSelect = require 'components/evidence_syntheses/progress_select'
QuestionsActions = require 'actions/questions_actions'
QuestionsStatusesStore = require 'stores/questions_statuses_store'
Router = require 'router'
{ DOCUMENT_STATUSES } = require 'lib/document_sections_v2_helper'
{ useCoffeeCallback, useI18n, useCoffeeMemo } = require 'lib/react_utils'

storeConnector =
  QuestionsStatusesStore: (Store, props) ->
    questionStatuses: Store.getQuestionStatuses props.data.get '_id'

MiniDocumentListItem = ({ data: doc, questionStatuses }) ->

  i18n = useI18n('mda:docs')

  handleEdit = useCoffeeCallback [], (doc) -> ->
    MiniDSActions.openCreateOrEditDialog doc

  handleDelete = useCoffeeCallback [doc], ->
    QuestionsActions.deleteQuestion doc.get '_id'

  handleDuplicate = useCoffeeCallback [doc], ->
    QuestionsActions.duplicateQuestion questionId: doc.get '_id'

  userAccessRights = mediator.user.getAccessRights()

  { controls, isAdmin } = useCoffeeMemo [doc, userAccessRights], ->
    isAdmin = _.contains userAccessRights, 'admin'
    controls = if isAdmin
      [
        name: 'edit'
        handler: handleEdit doc
      ,
        name: 'delete'
        handler: handleDelete
      ]
    else []
    { controls, isAdmin }

  currentStatus = useCoffeeMemo [questionStatuses], ->
    questionStatuses.get('documentStatus', Immutable.Map())

  currentUserEmail = useCoffeeMemo [], -> mediator.user.getEmail().toLowerCase()

  handleClick = useCoffeeCallback [doc], ->
    link = Router::routeForSubmodule 'mda-handouts', null, questionId: doc.get '_id'
    mediator.publish '!router:route', link

  <CollapsibleWithControls controls={controls}>
    <div className="question-text flex flex-row items-center">
      <div onClick={handleClick} className="pl-10 flex-grow cursor-pointer">
        <EllipsizedText height={40} text={doc.get('name') or ''} />
      </div>
      <div>
        <ProgressSelect
          questionId={doc.get '_id'}
          questionStatuses={questionStatuses}
          showLabel={false}
          statusesList={Immutable.fromJS(DOCUMENT_STATUSES)}
          groupKey='documentStatus'
          withCompleted={false}
          editable={isAdmin}
        />
      </div>
    </div>
  </CollapsibleWithControls>

MiniDocumentListItem.propTypes =
  data: PropTypes.instanceOf(Immutable.Map)
  questionStatuses: PropTypes.instanceOf(Immutable.Map)

module.exports = ConnectStore MiniDocumentListItem, [QuestionsStatusesStore], storeConnector
